import { Autocomplete, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { SeznamAutocomplete } from '../../../types/external/seznamAutocomplete';
import { handleEnterAsTab } from '../../../utils/handleEnterAsTab';
import { AutocompleteInput } from '../../common/AutocompleteInput';
import { RegistryIdName } from '../../types/accident';
import { UserPrefix } from '../AccidenCreatingStepCustomerInformations';

/** Autocomplete adresy + Ulice + Číslo popisné + Město + PSČ + Země */
export const AddressFields = ({
  prefix,
  control,
  countryList,
  autocompleteResults,
  onAutocompleteSearch,
  onAutocompleteSelect,
  isLoadingAddressData
}: {
  prefix: UserPrefix;
  control: any;
  countryList?: RegistryIdName[];
  autocompleteResults: SeznamAutocomplete[];
  onAutocompleteSearch: (value: string) => void;
  onAutocompleteSelect: (value: SeznamAutocomplete) => void;
  isLoadingAddressData?: boolean;
}) => (
  <>
    <AutocompleteInput
      autocompleteItems={autocompleteResults}
      onSearch={onAutocompleteSearch}
      onSelect={onAutocompleteSelect}
      isLoading={isLoadingAddressData}
    />
    {(['street', 'houseNum', 'city', 'zip'] as const).map((fieldName) => (
      <Controller
        key={fieldName}
        control={control}
        name={`${prefix}.address.${fieldName}`}
        render={({ field }) => (
          <TextField
            {...field}
            value={field.value ?? ''}
            label={
              {
                street: 'Ulice',
                houseNum: 'Číslo popisné',
                city: 'Město',
                zip: 'PSČ'
              }[fieldName]
            }
            color="secondary"
            fullWidth
            InputLabelProps={{ shrink: true }}
            onKeyDown={handleEnterAsTab}
          />
        )}
      />
    ))}
    <Controller
      control={control}
      name={`${prefix}.address.countryId`}
      render={({ field, fieldState: { error } }) => {
        const options = countryList ?? [];
        const selected = options.find((o) => o.id === field.value) ?? null;
        return (
          <Autocomplete<RegistryIdName, false, false, false>
            disablePortal
            options={options}
            value={selected}
            onChange={(_, option) => field.onChange(option ? option.id : null)}
            getOptionLabel={(opt) => opt?.name ?? ''}
            isOptionEqualToValue={(opt, val) => opt.id === val.id}
            loading={!options.length}
            renderInput={(params) => (
              <TextField {...params} label="Země" fullWidth required error={!!error} helperText={error?.message} />
            )}
          />
        );
      }}
    />
  </>
);
